export const trimOssUrl = (string) => {
  if (string && string !== "") {
    let parsed = string.split("?");
    return parsed[0];
  }
  return string;
}